import { z } from "zod";

export const ExerciseKind = z.enum(["MCQ", "NUMERIC", "EXPRESSION", "DRAG_POINT", "ORDERING", "OPEN"]);

/** Instance tirée pour un élève : énoncé rendu, paramètres, jamais la réponse. */
export const ExerciseInstance = z.object({
  instanceId: z.string().uuid(),
  templateId: z.string(),
  notionId: z.string(),
  kind: ExerciseKind,
  difficulty: z.number().int().min(1).max(5),
  prompt: z.string(), // énoncé rendu dans la langue demandée (markdown + $latex$)
  params: z.record(z.number()),
  choices: z.array(z.object({ id: z.string(), label: z.string() })).optional(), // MCQ
  figure: z.object({ assetId: z.string(), params: z.record(z.number()) }).optional(),
  hintsAvailable: z.number().int().default(3),
});
export type ExerciseInstance = z.infer<typeof ExerciseInstance>;

export const AnswerSubmission = z.object({
  attemptId: z.string().uuid(), // UUID v7 généré sur l'appareil
  instanceId: z.string().uuid(),
  answer: z.union([z.number(), z.string(), z.array(z.string()), z.object({ x: z.number(), y: z.number() })]),
  hintsUsed: z.number().int().min(0).max(3),
  durationMs: z.number().int().min(0),
  occurredAt: z.string().datetime(),
});
export type AnswerSubmission = z.infer<typeof AnswerSubmission>;

export const AnswerResult = z.object({
  attemptId: z.string().uuid(),
  isCorrect: z.boolean(),
  expected: z.union([z.number(), z.string()]).optional(), // renvoyé seulement après la dernière tentative autorisée
  nextHint: z.object({ level: z.number().int(), text: z.string() }).nullable(),
  masteryDelta: z.number().optional(),
});
export type AnswerResult = z.infer<typeof AnswerResult>;
